import { useBillingMeQuery } from '~/api/queries/billing';

export const useFreePlan = () => {
  const { data } = useBillingMeQuery();

  const isFreePlanUser = computed(() => data.value?.isNewFreePlanUser === true);

  return { isFreePlanUser };
};
